/**
 * Site-wide constants (single source of truth).
 *
 * Anything operator-supplied that appears in MORE than one place lives here so
 * changes are one-line edits. Pulled from bluekeys.co/contact + bluekeys.co/about-2
 * on 2026-05-17.
 *
 * NOTE: keep this file dependency-free — it's imported by both server and
 * client components.
 */

/** WhatsApp Business number (digits only, country code prefix, no `+`).
 *  Used to build `https://wa.me/<digits>` links across the site. */
export const WHATSAPP_NUMBER = "201044414367";

/** Pre-formatted href for any WhatsApp CTA.
 *  Pass an optional message to pre-fill the chat. */
export function whatsappHref(message?: string): string {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

/** Display version of the number (with country code "+", spaces). */
export const WHATSAPP_DISPLAY = "+20 104 441 4367";

/** Operator reservations phone (call/SMS, not WhatsApp). */
export const RESERVATIONS_PHONE = "+201044414367";

/** Inbox for reservation inquiries. */
export const RESERVATIONS_EMAIL = "Reservations@bluekeys.co";

/** Physical office address. */
export const OFFICE_ADDRESS =
  "Kamelizer Spaces, District 5, New Cairo, Cairo, Egypt";

/** Brokers portal: show the "Share via WhatsApp" button on unit pages.
 *  Default OFF — the WhatsApp mechanism was deferred (2026-06-03). Flip to
 *  `true` to enable a pre-filled share link with NO fixed recipient (the
 *  broker chooses who to forward it to). */
export const BROKER_WHATSAPP_ENABLED = false;

/** Flat commission brokers earn, shown per-unit on the broker portal (applied
 *  to the nightly price). Single source of truth — change here to adjust it
 *  everywhere on the broker surface. */
export const BROKER_COMMISSION_PCT = 5;

/** WhatsApp share link with NO fixed recipient — the sender picks the chat.
 *  Distinct from whatsappHref(), which always targets the BlueKeys number. */
export function whatsappShareHref(message: string): string {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
